import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../theme'

const { width } = Dimensions.get('window')

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'white',
        marginBottom: 300,
    },
    containerCard: {
        flex: 1,
        backgroundColor: 'white',
    },
    containerRow: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    containerScheduleWeek: {
        marginHorizontal: 12,
        paddingVertical: 16,
        marginBottom: 16,
        borderRadius: 15,
    },
    containerNoSchedule: {
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'center',
        marginTop: 180,
    },
    imageNoSchedule: {
        width: 120,
        height: 120,
    },
    titleNoSchedule: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 5,
        marginTop: 10,
        paddingHorizontal: 30,
    },
    descriptionNoSchedule: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        paddingHorizontal: 40,
    },
    title: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.textPrimary,
        marginHorizontal: 12,
    },
    date: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textPrimary,
        //marginHorizontal: 12,
    },
    section: {
        fontSize: 15,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        marginHorizontal: 12,
    },
    subSection: {
        fontSize: 15,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        marginHorizontal: 12,
    },
    month: {
        fontSize: 14,
        fontWeight: 'bold',
        color: 'white',
        alignSelf: 'center',
        marginHorizontal: 12,
    },
    containerDay: {
        width: 45,
        height: 32,
        borderRadius: 5,
        marginHorizontal: 4,
        marginTop: 6,
        justifyContent: 'center',
        alignItems: 'center',
    },
    daySelected: {
        borderWidth: 1,
        borderRadius: 8,
        borderColor: 'white',
        paddingVertical: 4,
        paddingHorizontal: 2,
    },
    day: {
        fontSize: 13,
        fontWeight: 'bold',
        color: 'white',
        alignSelf: 'center',
        marginHorizontal: 8,
    },
    dayNumber: {
        fontSize: 15,
        fontWeight: 'bold',
        color: 'white',
        alignSelf: 'center',
        marginHorizontal: 4,
    },
    input: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        height: 40,
        borderWidth: 0.5,
        borderRadius: 5,
        borderColor: theme.colors.lightGray,
        paddingVertical: 0,
        paddingRight: 10,
        marginHorizontal: 0,
        marginTop: 8,
        alignItems: 'center',
        color: theme.colors.textPrimary,
    },
    inputDropdownMenuSubsection: {
        borderWidth: 0.5,
        borderRadius: 5,
        borderColor: theme.colors.lightGray,
        color: theme.colors.textPrimary,
        marginHorizontal: 12,
    },
    title: {
        fontSize: 16,
        fontWeight: 'bold',
        color: theme.colors.textSecondary,
        marginHorizontal: 12,
    },
    subtitle: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        marginHorizontal: 12,
    },
    activity: {
        fontSize: 14,
        fontWeight: '500',
        color: theme.colors.textPrimary,
        lineHeight: 19,
        margin: 2,
    },
    option: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.textPrimary,
        marginHorizontal: 12,
    },
    label: {
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: 5,
        backgroundColor: theme.colors.colorSecondary,
        paddingHorizontal: 8,
        paddingVertical: 4,
    },
    labelBis: {
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: 5,
        borderColor: theme.colors.colorSecondary,
        borderWidth: 0.5,
        backgroundColor: 'white',
        paddingHorizontal: 8,
        paddingVertical: 4,
    },
    frequency: {
        fontSize: 14,
        fontWeight: 'bold',
        color: 'white',
    },
    frequencyBis: {
        fontSize: 14,
        fontWeight: 'bold',
        color: theme.colors.colorSecondary,
    },
    optionUnselected: {
        borderWidth: 1,
        borderRadius: 5,
        borderColor: theme.colors.lightGray,
        paddingVertical: 6,
    },
    optionSelected: {
        borderWidth: 1,
        borderRadius: 5,
        borderColor: theme.colors.colorPrimary,
        paddingVertical: 6,
        marginTop: 12,
    },
    optionSelectedCheck: {
        borderWidth: 1,
        borderRadius: 5,
        borderColor: theme.colors.colorApproved,
        paddingVertical: 6,
    },
    optionSelectedClose: {
        borderWidth: 1,
        borderRadius: 5,
        borderColor: theme.colors.colorDisapproved,
        paddingVertical: 6,
    },
    cardContainer: {
        borderWidth: 1,
        flex: 1,
        borderColor: theme.colors.lightGray,
        padding: 10,
        borderRadius: 8,
        marginVertical: 8,
        marginHorizontal: 12,
    },
    header: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    headerText: {
        fontSize: 16,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        marginLeft: 6,
    },
    containerOption: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 8,
    },
    optionText: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.textPrimary,
        marginLeft: 6,
    },
    infoContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        marginVertical: 5,
    },
    containerData: {
        flexDirection: 'row',
        alignItems: 'center',
        marginEnd: 12,
    },
    separator: {
        color: theme.colors.textSecondary,
    },
    infoText: {
        fontSize: 12,
        color: theme.colors.textSecondary,
        marginRight: 6,
    },
    storecode: {
        fontSize: 12,
        fontWeight: 'bold',
        color: theme.colors.textSecondary,
    },
    addressText: {
        fontSize: 14,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
    },
    textButton: {
        fontSize: 14,
        fontWeight: 'bold',
        color: theme.colors.colorPrimary,
        marginHorizontal: 6,
    },
    marginHorizontal: { marginHorizontal: 12 },
    marginLeft: { marginLeft: 12 },
    marginRight: { marginRight: 12 },
    paddingBottom: { paddingBottom: 12 },
    paddingHorizontal: { paddingHorizontal: 6 },
    paddingRight: { paddingRight: 4 },
    alignCenter: { alignSelf: 'center' },
    maxWidth: { maxWidth: '70%' },
    spaceBetween: {
        justifyContent: 'space-between',
    },
    divider: {
        flex: 1,
        borderWidth: 0.5,
        borderColor: theme.colors.lightGray,
        marginHorizontal: 12,
    },
    spacerMin: {
        height: 4,
    },
    spacer: {
        height: 8,
    },
    spacer1: {
        height: 20,
    },
    spacer2: {
        height: 16,
    },
    spacer3: {
        height: 80,
    },
})

export default styles
